module.exports = __webpack_public_path__ + "static/media/notifications-alert-disabled.4f3ef34a.svg";